// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__eyJpx","left":"InfoRow_left__KZtmz"};